import {LanguageSetting} from "@serengeti/serengeti-mailer";
import {Observable} from "rxjs";

export const environment = {
	// production: true,
	// version: null,
	// profile: 'incheon.product',
	// content: {} as any,
	// serviceEndPoint: 'http://127.0.0.1',
	// serviceMemberEndPoint: 'http://127.0.0.1:30014/api.login/auth/v1/handle/',
	// serviceUserEndPoint: 'http://127.0.0.1:30013/api.user/user/v1/handle/',
	// serviceMenuEndPoint: 'http://127.0.0.1:30012/api.menu/menu/v1/handle/',
	// serviceConfigEndPoint: 'http://127.0.0.1:30010/api.config/config/v1/handle/',
	// serviceCodeEndPoint: 'http://127.0.0.1:30010/api.config/config/v1/handle/',

	// serviceResourceEndPoint: 'http://127.0.0.1:30018/',
	// serviceResourceCoreEndPoint: 'http://127.0.0.1:30018/api.resource/resource/v1/handle/',
	// serviceResourceFileEndPoint: 'http://127.0.0.1:30028/api.filemanager/file/v1/handle/',
	// serviceResourceConsoleEndPoint: 'http://127.0.0.1:30017/api.console/console/v1/handle/',
	// serviceResourceTemplateEndPoint: 'http://127.0.0.1:30021/api.template/',
	// serviceResourceTaskEndPoint: 'http://127.0.0.1:30025/be.rstask/backend/v1/resource-task/handle/',

	// serviceApplicationCoreEndPoint: 'http://127.0.0.1:30015/api.app/app/v1/handle/',
	// serviceExecutionCoreEndPoint: 'http://127.0.0.1:30024/be.execute/backend/v1/execute/handle',
	// serviceNotificationEndPoint: 'http://127.0.0.1:30023/api.notification/',
	// serviceBillingEndPoint: 'http://127.0.0.1:30016/api.billing/billing/v1/handle/',
	// serviceMailEndPoint: 'http://127.0.0.1:30019/be.mailer/backend/v1/mail/handle/',
	// serviceMonitoringEndPoint: 'http://127.0.0.1:30022/api.monitoring/monitoring/v1/handle/',
	// serviceSchedulerEndPoint: 'http://127.0.0.1:30027/api.scheduler/scheduler/v1/handle/',
	// serviceProjectEndPoint: 'http://127.0.0.1:30020/api.service/service/v1/handle/',
	// serviceBoardEndPoint : 'http://127.0.0.1:30030/board/v1/handle/',

	// production: true,
	// version: null,
	// profile: 'incheon.staging',
	// content: {} as any,
	// serviceEndPoint: 'http://10.122.64.84',
	// serviceMemberEndPoint: 'http://10.122.64.84/api.login/auth/v1/handle/',
	// serviceUserEndPoint: 'http://10.122.64.84/api.user/user/v1/handle/',
	// serviceMenuEndPoint: 'http://10.122.64.84/api.menu/menu/v1/handle/',
	// serviceConfigEndPoint: 'http://10.122.64.84/api.config/config/v1/handle/',
	// serviceCodeEndPoint: 'http://10.122.64.84/api.config/config/v1/handle/',

	// serviceResourceEndPoint: 'http://10.122.64.84/',
	// serviceResourceCoreEndPoint: 'http://10.122.64.84/api.resource/resource/v1/handle/',
	// serviceResourceFileEndPoint: 'http://10.122.64.84/api.filemanager/file/v1/handle/',
	// serviceResourceConsoleEndPoint: 'http://10.122.64.84/api.console/console/v1/handle/',
	// serviceResourceTemplateEndPoint: 'http://10.122.64.84/api.template/',
	// serviceResourceTaskEndPoint: 'http://10.122.64.84/be.rstask/backend/v1/resource-task/handle/',

	// serviceApplicationCoreEndPoint: 'http://abc/api.app/app/v1/handle/',
	// serviceExecutionCoreEndPoint: 'http://10.122.64.84/be.execute/backend/v1/execute/handle',
	// serviceNotificationEndPoint: 'http://10.122.64.84/api.notification/',
	// serviceBillingEndPoint: 'http://10.122.64.84/api.billing/billing/v1/handle/',
	// serviceMailEndPoint: 'http://10.122.64.84/be.mailer/backend/v1/mail/handle/',
	// serviceMonitoringEndPoint: 'http://10.122.64.84/api.monitoring/monitoring/v1/handle/',
	// serviceSchedulerEndPoint: 'http://10.122.64.84/api.scheduler/scheduler/v1/handle/',
	// serviceProjectEndPoint: 'http://10.122.64.84/api.service/service/v1/handle/',
	// serviceBoardEndPoint : 'http://10.122.64.84/api.board/board/v1/handle/',

	production: true,
	version: '2.5.21.1013',
	profile: 'staging',
	guideUrl: 'http://183.111.79.31:30001/',
	menuNavigation: 'sidepopup',
	supportedLanguages: new LanguageSetting(),
	content: {} as any,
	serviceTheme: 'light',
	isKeycloakUsed: 'false',
	chatbotUsed: 'false',

	serviceDomainEndPoint: 'https://serengeti.aifrica.co.kr',
	serviceEndPoint: 'https://serengeti.aifrica.co.kr',
	serviceMemberEndPoint: 'https://serengeti.aifrica.co.kr/api.login/auth/v1/handle/',
	serviceUserEndPoint: 'https://serengeti.aifrica.co.kr/api.user/user/v1/handle/',
	serviceMenuEndPoint: 'https://serengeti.aifrica.co.kr/api.menu/menu/v1/handle/',
	serviceConfigEndPoint: 'https://serengeti.aifrica.co.kr/api.config/config/v1/handle/',
	serviceCodeEndPoint: 'https://serengeti.aifrica.co.kr/api.config/config/v1/handle/',
  	serviceCloudAccountEndPoint : 'https://serengeti.aifrica.co.kr/api.cloud.account/account/v1/handle/',

  	servicePrivateResourceEndPoint: "https://serengeti-api-resource/api.resource/resource/v1/handle/",
	serviceResourceEndPoint: 'https://serengeti.aifrica.co.kr/',
	serviceResourceCoreEndPoint: 'https://serengeti.aifrica.co.kr/api.resource/resource/v1/handle/',
	serviceResourceFileEndPoint: 'https://serengeti.aifrica.co.kr/api.filemanager/file/v1/handle/',
	serviceResourceConsoleEndPoint: 'https://serengeti.aifrica.co.kr/api.console/console/v1/handle/',
	serviceResourceTemplateEndPoint: 'https://serengeti.aifrica.co.kr/api.template/',
	serviceResourceTaskEndPoint: 'https://serengeti.aifrica.co.kr/be.rstask/backend/v1/resource-task/handle/',

	serviceApplicationCoreEndPoint: 'http://localhost:30015/api.app/app/v1/handle/',
	serviceExecutionCoreEndPoint: 'https://serengeti.aifrica.co.kr/be.execute/backend/v1/execute/handle',
  serviceVariableEndPoint: 'https://serengeti.aifrica.co.kr/api.scheduler/scheduler/v1/handle/task/variable',
	serviceNotificationEndPoint: 'https://serengeti.aifrica.co.kr/api.notification/',
	serviceBillingEndPoint: 'https://serengeti.aifrica.co.kr/api.billing/billing/v1/handle/',
	serviceMailEndPoint: 'https://serengeti.aifrica.co.kr/be.mailer/backend/v1/mail/handle/',
  serviceMeteringEndPoint: 'https://serengeti.aifrica.co.kr/api.metering/metering/v1/handle',
	serviceMonitoringEndPoint: 'https://serengeti.aifrica.co.kr/api.monitoring/monitoring/v1/handle/',
	serviceSchedulerEndPoint: 'https://serengeti.aifrica.co.kr/api.scheduler/scheduler/v1/handle/',
	serviceProjectEndPoint: 'https://serengeti.aifrica.co.kr/api.service/service/v1/handle/',
	serviceBoardEndPoint : 'https://serengeti.aifrica.co.kr/api.board/board/v1/handle/',
	serviceDatastoreEndPoint : 'https://serengeti.aifrica.co.kr/api.datastore/datastore/v1/handle/',
	serviceMindsLabEndPoint : 'https://serengeti.aifrica.co.kr/api.mindslab/stat/v1/handle/',

	serviceChatEndPoint : 'https://serengeti.aifrica.co.kr/api.chat/chat/v1/handle/',
	serviceWebSocketEndPoint : 'https://serengeti.aifrica.co.kr/api.chat/ws',

	serviceDashboardEndPoint : 'https://serengeti.aifrica.co.kr/api.dashboard/dashboard/v1/handle/',
	serviceMarketEndPoint : "https://serengeti.aifrica.co.kr/api.market/market/v1/handle/",
	serviceOrderEndPoint : "https://serengeti.aifrica.co.kr/api.order/order/v1/handle/",
	serviceApprovalEndPoint : "https://serengeti.aifrica.co.kr/api.approval/process/v1/handle/",

	serviceSurveyEndPoint : "https://serengeti.aifrica.co.kr/api.survey/survey/v1/handle/",
	serviceTokenEndPoint : "https://serengeti.aifrica.co.kr/api.token/token/v1/handle/",

	serviceMonacoEditorEndPoint : "wss://serengeti.aifrica.co.kr/monaco-editor",

	serviceProxyEndPoint : 'https://serengeti.aifrica.co.kr/api.proxy/proxy/v1/handle/',

	serviceResourceWebsocketExecuteEndPoint: 'https://serengeti.aifrica.co.kr/api.monitoring/ws',

	serviceResourceMonitoringEndPoint: 'https://serengeti.aifrica.co.kr/api.resource/resource/v1/handle/monitoring',
  serviceApiManagerEndPoint: 'https://serengeti.aifrica.co.kr/api.api-manager/api/v1/handle/',
  serviceKeycloakEndPoint: 'https://serengeti.aifrica.co.kr/api.keycloak/keycloak/v1/handle',
  serviceAppDevEndPoint: 'https://api.serengeti.aifrica.co.kr/api.dev/dev/v1/handle/',
  serviceChatbotEndPoint: 'https://api.serengeti.aifrica.co.kr/api.chatbot/',
	serviceKeycloakLogoutEndpoint: '',
	serviceThemeObject: null as Observable<any>,

};
